<template>
  <div>
    <div class="flex flex-col" @click="router.push(`/news/${article.uid}`)">
        <Image v-if="thumbnail && thumbnail.length > 0" :src="thumbnail" type="thumbnail" class="mb-4" />
      <p class="text-body-5 font-medium text-default-1 mb-1 hover:text-primary-1"> {{ article.title }}</p>
      <p class="text-body-7 text-default-2">{{moment(article.created_at).format("MMM DD, YYYY")}}</p>
      <p v-if="!isMobile" class="text-body-6 font-medium text-default-2 mt-4 mb-4 w-full overflow-hidden overflow-ellipsis max-h-[60px] multi-line-ellipsis clamp-3-lines" v-html="processedHtml"/>
    </div>
    <div class="flex mt-auto">
        <Like
            :likes-count="article.total_likes"
            :is-liked="article.is_liked"
            :articleUid="article.uid"
            @toggle-like="$emit('toggleLike')"
            :has-background-style="false"
            :class="{'mt-4': isMobile}"
        />
      <div class="flex ml-4 items-center" v-if="article.tags && article.tags.length > 0">
        <img src="@/assets/icons/tag.svg" alt="tag" class="mr-2.5" />
        <p class="text-body-7 font-medium text-default-2 capitalize">{{ article.tags[0] }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import moment from "moment";
import {computed} from "vue";
import Like from "@/components/custom/news/Like.vue";
import router from "@/router";
import {useIsMobile} from "@/composables/useIsMobile";
import Image from "@/components/custom/Image.vue";

const {isMobile} = useIsMobile();

const emit = defineEmits(["toggleLike"]);
const props = defineProps({
    article : {
        type: Object
    }
});

const thumbnail = computed(() => {
    if (!props.article || !props.article.thumbnail || props.article.thumbnail.length === 0) {
        return "";
    }

    return props.article.thumbnail;
});

const processedHtml = computed(() => {
    return props.article.body.replace(/<img[^>]*>/g, '');
});
</script>
